export const isBrowser = typeof window === "object" && typeof document === "object";
